/** WebAudio synthesized alert beep — no binary asset required. */

let _ctx = null;

function ctx() {
  if (typeof window === "undefined") return null;
  const Cls = window.AudioContext || window.webkitAudioContext;
  if (!Cls) return null;
  if (!_ctx) _ctx = new Cls();
  return _ctx;
}

const STORAGE_KEY = "signalagent_sound_enabled";

export function isSoundEnabled() {
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === null) return true; // default ON
  return v === "1";
}

export function setSoundEnabled(on) {
  localStorage.setItem(STORAGE_KEY, on ? "1" : "0");
}

/** Two-tone alarm (880Hz then 440Hz, ~200ms each). */
export function playRedAlertBeep() {
  if (!isSoundEnabled()) return;
  const c = ctx();
  if (!c) return;
  // Resume if suspended (Chrome autoplay policy)
  if (c.state === "suspended") {
    try {
      c.resume();
    } catch (_e) {
      /* ignore */
    }
  }
  const t0 = c.currentTime;
  const tones = [
    { freq: 880, start: t0, dur: 0.18 },
    { freq: 440, start: t0 + 0.22, dur: 0.18 },
  ];
  for (const t of tones) {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = t.freq;
    gain.gain.setValueAtTime(0.0001, t.start);
    gain.gain.exponentialRampToValueAtTime(0.18, t.start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t.start + t.dur);
    osc.connect(gain).connect(c.destination);
    osc.start(t.start);
    osc.stop(t.start + t.dur + 0.02);
  }
}
